'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Masthead = exports.ENGAGEMENT_ELEMENTS = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = require('react-redux');

var _Link = require('../Link');

var _Link2 = _interopRequireDefault(_Link);

var _Search = require('../Search');

var _Search2 = _interopRequireDefault(_Search);

var _coreNavigationUi = require('../../redux/core-navigation-ui');

var _props = require('../props');

var _svg = require('../svg');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_SEARCH_LABEL = 'SEARCH'; /* eslint-disable import/no-named-as-default, max-len */
/* global window */

var DEFAULT_SEARCH_PLACEHOLDER_LABEL = 'SEARCH';
var DEFAULT_MENU_CLOSED_LABEL = 'MENU';
var DEFAULT_MENU_OPENED_LABEL = 'CLOSE';

var ENGAGEMENT_ELEMENTS = exports.ENGAGEMENT_ELEMENTS = {
    LOGO: 'Masthead_Logo',
    SECTION: 'Masthead_Section',
    MENUTOGGLED: 'Menu_Toggled'
};

var logoClick = function logoClick(engagement, name) {
    return function (event) {
        engagement({
            elementIdentifier: ENGAGEMENT_ELEMENTS.LOGO,
            meta: { name: name, event: event }
        });
    };
};

var sectionClick = function sectionClick(engagement, name, position) {
    return function (event) {
        engagement({
            elementIdentifier: ENGAGEMENT_ELEMENTS.SECTION + '_' + position,
            meta: { name: name, event: event }
        });
    };
};

var Masthead = exports.Masthead = function Masthead(props) {
    var theme = props.theme,
        masthead = props.masthead,
        importantSections = props.importantSections,
        mainMenuOpened = props.mainMenuOpened,
        dispatch = props.dispatch,
        engagement = props.engagement;

    var searchClass = mainMenuOpened ? theme['navSearchContainer-menuOpen'] : theme.navSearchContainer;
    var linksClass = mainMenuOpened ? theme['mainLinks-menuOpen'] : theme.mainLinks;
    var labelClosedClass = mainMenuOpened ? theme['menuLabelClosed-menuOpen'] : theme.menuLabelClosed;
    var labelOpenClass = mainMenuOpened ? theme['menuLabelOpen-menuOpen'] : theme.menuLabelOpen;
    var iconClass = mainMenuOpened ? theme['menuIconInner-menuOpen'] : theme.menuIconInner;
    var logoTitle = masthead.publicationName ? _react2.default.createElement(
        'h1',
        { className: theme.iconLabel },
        masthead.publicationName
    ) : null;
    var _masthead$labels = masthead.labels,
        _masthead$labels$sear = _masthead$labels.search,
        searchLabel = _masthead$labels$sear === undefined ? DEFAULT_SEARCH_LABEL : _masthead$labels$sear,
        _masthead$labels$sear2 = _masthead$labels.searchPlaceholder,
        searchPlaceholderLabel = _masthead$labels$sear2 === undefined ? DEFAULT_SEARCH_PLACEHOLDER_LABEL : _masthead$labels$sear2,
        _masthead$labels$menu = _masthead$labels.menuClosed,
        menuClosedLabel = _masthead$labels$menu === undefined ? DEFAULT_MENU_CLOSED_LABEL : _masthead$labels$menu,
        _masthead$labels$menu2 = _masthead$labels.menuOpened,
        menuOpenedLabel = _masthead$labels$menu2 === undefined ? DEFAULT_MENU_OPENED_LABEL : _masthead$labels$menu2;


    return _react2.default.createElement(
        'div',
        { className: theme.masthead },
        _react2.default.createElement(
            'div',
            { className: theme.innerContainer },
            _react2.default.createElement(
                _Link2.default,
                {
                    className: theme.logo,
                    link: masthead.logoUrl,
                    onClick: logoClick(engagement, masthead.svg.logo.label),
                    enableSinglePage: true
                },
                _react2.default.createElement(_svg.LogoSvg, { icon: masthead.svg.logo, title: masthead.publicationName }),
                logoTitle
            ),
            _react2.default.createElement(
                'div',
                { className: searchClass },
                _react2.default.createElement(
                    'nav',
                    { className: linksClass, role: 'navigation', 'aria-label': 'quick navigation' },
                    _react2.default.createElement(
                        'ul',
                        { className: theme.navList },
                        importantSections.map(function (item, index) {
                            return _react2.default.createElement(
                                'li',
                                { key: item.key || item.name, className: (0, _classnames2.default)(theme.mainItem, theme[item.key]) },
                                _react2.default.createElement(
                                    _Link2.default,
                                    {
                                        link: item.url,
                                        className: theme.mainLink,
                                        tabIndex: mainMenuOpened ? -1 : 0,
                                        onClick: sectionClick(engagement, item.name, index + 1),
                                        enableSinglePage: true
                                    },
                                    item.name
                                )
                            );
                        })
                    )
                )
            ),
            _react2.default.createElement(
                'div',
                { className: theme.widgets },
                masthead.search ? _react2.default.createElement(_Search2.default, {
                    theme: theme,
                    searchLabel: searchLabel,
                    searchPlaceholderLabel: searchPlaceholderLabel,
                    searchSvg: masthead.svg.search,
                    searchClearSvg: masthead.svg.searchClear,
                    searchUrl: masthead.search.url,
                    engagement: engagement,
                    onSearchPhraseSubmitted: function onSearchPhraseSubmitted(url) {
                        window.location.href = url;
                    }
                }) : null,
                _react2.default.createElement(
                    'button',
                    {
                        className: theme.menuTrigger,
                        'aria-controls': 'navigation',
                        'aria-label': 'Meny',
                        onClick: function onClick(event) {
                            engagement({
                                elementIdentifier: ENGAGEMENT_ELEMENTS.MENUTOGGLED,
                                meta: { event: event }
                            });
                            dispatch(_coreNavigationUi.actions.toggleMainMenu());
                        }
                    },
                    _react2.default.createElement(
                        'span',
                        { className: labelClosedClass },
                        menuClosedLabel
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: labelOpenClass },
                        menuOpenedLabel
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: theme.menuIcon },
                        _react2.default.createElement(
                            'span',
                            { className: theme.menuIconBox },
                            _react2.default.createElement('span', { className: iconClass })
                        )
                    )
                )
            )
        )
    );
};

if (process.env.NODE_ENV !== 'production') {
    Masthead.propTypes = {
        engagement: _propTypes2.default.func,
        dispatch: _propTypes2.default.func.isRequired,
        mainMenuOpened: _propTypes2.default.bool.isRequired,
        masthead: _propTypes2.default.shape(_props.mastheadProps).isRequired,
        importantSections: _propTypes2.default.arrayOf(_propTypes2.default.shape(_props.sectionProps)).isRequired,
        theme: _propTypes2.default.shape({
            masthead: _propTypes2.default.string,
            innerContainer: _propTypes2.default.string,
            logo: _propTypes2.default.string,
            iconLabel: _propTypes2.default.string,
            navSearchContainer: _propTypes2.default.string,
            mainLinks: _propTypes2.default.string,
            navList: _propTypes2.default.string,
            mainItem: _propTypes2.default.string,
            mainLink: _propTypes2.default.string,
            loader: _propTypes2.default.string,
            widgets: _propTypes2.default.string,
            menuTrigger: _propTypes2.default.string,
            menuLabelOpen: _propTypes2.default.string,
            menuLabelClosed: _propTypes2.default.string,
            menuIcon: _propTypes2.default.string,
            menuIconBox: _propTypes2.default.string,
            menuIconInner: _propTypes2.default.string
        })
    };
}

Masthead.defaultProps = {
    engagement: function engagement() {},
    theme: {}
};

exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        mainMenuOpened: state.coreNavigationUI.main.mainMenuOpened
    };
})(Masthead);
//# sourceMappingURL=Masthead.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/components/Masthead/Masthead.js
 ** module id = 603
 ** module chunks = 1
 **/